import gql from 'graphql-tag';

const QuickStartResultFields = gql`
	fragment QuickStartResultFields on ProjectQuickStart {
		projectId
		name
		id
		featuredPhoto {
			id
			publicId
			isFeatured
			url
		}
	}
`;

export const SHOP_BY_LOOK_PAGE = gql`
	${QuickStartResultFields}
	query ShopByLookPage(
		$featuredInput: ProjectQuickStartsSearchCriteriaInput!
		$favoriteInput: ProjectQuickStartsSearchCriteriaInput!
		$trendsInput: ProjectQuickStartsSearchCriteriaInput!
	) {
		featuredLooks: discoverableQuickStarts(criteria: $featuredInput) {
			quickStarts {
				... on ProjectQuickStart {
					...QuickStartResultFields
				}
			}
		}
		favoriteLooks: discoverableQuickStarts(criteria: $favoriteInput) {
			quickStarts {
				... on ProjectQuickStart {
					...QuickStartResultFields
				}
			}
		}
		trendsAndInfluences: discoverableQuickStarts(criteria: $trendsInput) {
			quickStarts {
				... on ProjectQuickStart {
					...QuickStartResultFields
				}
			}
		}
	}
`;
